export var ModalStoreActionKind;
(function (ModalStoreActionKind) {
    ModalStoreActionKind[ModalStoreActionKind["CLEAR"] = 0] = "CLEAR";
    ModalStoreActionKind[ModalStoreActionKind["QUEUE"] = 1] = "QUEUE";
    ModalStoreActionKind[ModalStoreActionKind["DEQUEUE"] = 2] = "DEQUEUE";
})(ModalStoreActionKind || (ModalStoreActionKind = {}));
const defaultState = { modals: new Map(), queue: new Set() };
export function ModalStoreReducer(state = defaultState, action) {
    switch (action.type) {
        case ModalStoreActionKind.QUEUE: {
            if (action.id && !state.queue.has(action.id)) {
                const queue = new Set([...state.queue]);
                queue.add(action.id);
                return { ...state, queue };
            }
            return state;
        }
        case ModalStoreActionKind.DEQUEUE: {
            if (action.id && state.queue.has(action.id)) {
                const queue = new Set([...state.queue]);
                queue.delete(action.id);
                return { ...state, queue };
            }
            return state;
        }
        case ModalStoreActionKind.CLEAR: {
            return { ...defaultState };
        }
        default:
            return state;
    }
}
//# sourceMappingURL=ModalReducer.js.map